// /opt/isp_erp/frontend/src/utils/validacionesEcuador.js
// Validación de cédula, RUC y pasaporte (Ecuador) y de correos. Mismas reglas que app/customers/validadores.py.
const PROVINCIAS = new Set([...Array.from({ length: 24 }, (_, i) => i + 1), 30]);
const EMAIL_RE = /^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;

const provinciaOk = (texto) => PROVINCIAS.has(parseInt(texto.slice(0, 2), 10));

const cedulaOk = (c) => {
  if (!/^[0-9]{10}$/.test(c) || !provinciaOk(c) || parseInt(c[2], 10) > 5) return false;
  let suma = 0;
  for (let i = 0; i < 9; i += 1) {
    let n = parseInt(c[i], 10) * (i % 2 === 0 ? 2 : 1);
    if (n > 9) n -= 9;
    suma += n;
  }
  return (10 - (suma % 10)) % 10 === parseInt(c[9], 10);
};

const rucOk = (r) => {
  if (!/^[0-9]{13}$/.test(r) || !provinciaOk(r)) return false;
  const tercero = parseInt(r[2], 10);
  // Persona natural: el SRI también emite RUC cuya cédula base no pasa el módulo 10; solo se revisa la estructura
  if (tercero <= 5) return parseInt(r.slice(10), 10) >= 1;
  // Sociedades: el SRI emitió RUC que NO cumplen el módulo 11; solo se revisa la estructura (establecimiento desde 001)
  if (tercero === 9) return parseInt(r.slice(10), 10) >= 1;
  // Entidades públicas: igual, el dígito verificador no es confiable; solo se revisa la estructura
  if (tercero === 6) return parseInt(r.slice(9), 10) >= 1;
  return false;
};

/** Devuelve { ok, mensaje, tipo }. El vacío se permite. */
export const validarIdentificacion = (valor, tipo) => {
  const v = String(valor || '').trim();
  if (!v) return { ok: true, mensaje: '', tipo: null };
  const t = String(tipo || '').trim().toUpperCase();
  if (t === 'PASAPORTE' || t === 'PASSPORT') {
    if (/^[A-Za-z0-9]{5,20}$/.test(v)) return { ok: true, mensaje: '', tipo: 'PASAPORTE' };
    return { ok: false, mensaje: 'El pasaporte debe tener entre 5 y 20 letras o números, sin espacios ni símbolos', tipo: 'PASAPORTE' };
  }
  if (/^[0-9]+$/.test(v)) {
    if (v.length === 10) {
      if (t === 'RUC') return { ok: false, mensaje: 'Un RUC tiene 13 dígitos', tipo: 'RUC' };
      if (cedulaOk(v)) return { ok: true, mensaje: '', tipo: 'CEDULA' };
      return { ok: false, mensaje: 'La cédula no es válida (revisa los dígitos)', tipo: 'CEDULA' };
    }
    if (v.length === 13) {
      if (t === 'CEDULA') return { ok: false, mensaje: 'Una cédula tiene 10 dígitos', tipo: 'CEDULA' };
      if (rucOk(v)) return { ok: true, mensaje: '', tipo: 'RUC' };
      return { ok: false, mensaje: 'El RUC no es válido (revisa los dígitos)', tipo: 'RUC' };
    }
    return { ok: false, mensaje: 'La cédula debe tener 10 dígitos y el RUC 13 (solo números)', tipo: null };
  }
  return { ok: false, mensaje: 'La cédula o el RUC solo admite números (sin espacios, guiones ni letras)', tipo: null };
};

/** Devuelve { ok, mensaje }. El vacío se permite. */
export const validarEmail = (valor) => {
  const v = String(valor || '').trim();
  if (!v) return { ok: true, mensaje: '' };
  if (v.length > 120) return { ok: false, mensaje: 'El correo es demasiado largo (máximo 120 caracteres)' };
  const malo = { ok: false, mensaje: 'El correo no es válido (ejemplo: nombre@dominio.com)' };
  if (v.split('@').length !== 2 || /\s/.test(v)) return malo;
  const local = v.split('@')[0];
  if (local.startsWith('.') || local.endsWith('.') || local.includes('..') || !EMAIL_RE.test(v)) return malo;
  return { ok: true, mensaje: '' };
};
